import { roleApi } from './../../../api/user/roleApi';
import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eRoleActionTypeIds } from "../../action-types/user/IRoleActionTypes";
import { actions } from "../../actions";

export function* roleSaga(): any {
    yield takeLatest(eRoleActionTypeIds.LOAD_START, loadWorker)
}
function* loadWorker(): any {
    const res: IBaseRespone = yield call(roleApi.getAll)
    if (res.is_success) {
        yield put(actions.role.loadSuccess(res.data))
    } else {
        yield put(actions.role.loadError(res.message))
    }
}